import React from "react";

const HeartIcon = () => {
  return (
    <svg
      width="26"
      height="24"
      viewBox="0 0 26 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13 23L2.7752 12.0652C1.63856 10.8495 1 9.2009 1 7.48182C1 3.90201 3.71356 1 7.06092 1C8.66837 1 10.21 1.68291 11.3467 2.89848L13 4.66667L14.6533 2.89848C15.79 1.68291 17.3316 1 18.9391 1C22.2864 1 25 3.90201 25 7.48182C25 9.2009 24.3615 10.8495 23.2248 12.0652L18.1124 17.5326"
        stroke="#3F3F3F"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default HeartIcon;
